<style>
.answer button{
    width:75px;
    height:75px;
    border-radius:100px;
    font-size:1.5rem;
}
</style>
<script>
import { notify } from '@/helpers/notify' 

export default {
    name: 'TicketModal',
    props:[
        "data",
        "modelOpen",
    ],
    data() {
        return {
            submitted: false,
            comment: '',
            surveys: [],
            cevaplar:[],
            status:'',
            openQuestion:false
        };
    },
    watch:{
        modelOpen(){
            this.cevaplar= [];
            this.comment = ''

            this.getQuestionList();
        },
    },
        computed: {
            aktifSoru() {

                if(!this.openQuestion) return 

                let index = this.cevaplar.length
                let next = this.surveys[index]
                
                if(!next) return
          
                if (!next) {
                    next = { order: index + 1 }
                } else {
                    next['order'] = index + 1
                }

                return next
            }
        },
    methods: {
        getQuestionList(){
            this.$http.post(`survey/get-questions`).then(response=>this.surveys = response.data)
        },
        send(){
            this.$http.post(`members/${this.data.id}/survey`, {
                        answers:this.cevaplar,
                        comment:this.comment,
                        status:this.status
                    })
                    .then(response =>{ 
                        notify.success(response.data.message)
                    })
                    .finally(()=>{
                        this.cevaplar= [];
                        this.comment = ''
                        this.$parent.$bvModal.hide('survey_modal')
                        this.$emit('loadItems')
                        })
        },
        close(){
            this.$parent.$bvModal.hide('survey_modal')
        },
        cevapEkle(id, yanit){
            this.cevaplar.push({ id, yanit });
            this.cevaplar.sort((a, b) => a.id - b.id);
        },
        resetSurvey(){
            this.cevaplar= [];
        },
        onay(){
            if(this.status != 'kabuletti'){
                this.$http.post(`members/${this.data.id}/survey`, {
                    status:this.status
                })
                .then(response =>{ 
                    notify.success(response.data.message)
                })
                .finally(()=>{
                    this.cevaplar= [];
                    this.comment = ''
                    this.$parent.$bvModal.hide('survey_modal')
                    this.$emit('loadItems')
                })
                return false;
            }
            this.openQuestion = true
        }
    },
};
</script>

<template>
<b-modal id="survey_modal" title="Memnuniyet Anketi" size="xl" no-close-on-backdrop hide-footer>
    <form>
        <div class="row mb-3" v-if="cevaplar.length > 0">
            <div class="col-12">
                <div class="float-start">
                <a href="#" @click.prevent="resetSurvey" style="text-decoration: none; color: #007bff;">Anketi Baştan Başlat</a>
                </div>
            </div>
        </div>
        <div class="row mb-1 " v-if="!openQuestion"> 
            <div class="col-md-6 col-form-label mx-auto">
                <div class="text-center"> 
                    <select v-model="status" class="form-select form-select-lg">
                        <option value="">Seçiniz</option>
                        <option value="reddetti">Reddetti</option>
                        <option value="ulasilamadi">Ulaşılamadı</option>
                        <option value="kabuletti">Kabul Etti</option>
                    </select>
                    <button type="button" class="btn btn-info btn-lg mt-2" @click="onay()">Onay</button>
                </div>
            </div>
        </div>
        <div class="row mb-1" v-if="aktifSoru"> 
            <div class="col-md-12 col-form-label">
                <div class="text-center"> 
                    <h4>{{ aktifSoru.order }}. <span style="font-weight: normal;">{{ aktifSoru.content_tr }}</span></h4>
                    <h4 class="mt-3">{{ aktifSoru.order }}. <span style="font-weight: normal;">{{ aktifSoru.content_en }}</span></h4>
                </div>
                 <div class="d-flex justify-content-center mt-5 answer" v-if="aktifSoru.type=='scored'">
                    <button type="button" style="background-color: #fb0909bf;" class="btn btn-danger me-5" @click="cevapEkle(aktifSoru.id, 1)">1</button>
                    <button type="button" class="btn btn-danger me-5" @click="cevapEkle(aktifSoru.id, 2)">2</button>
                    <button type="button" class="btn btn-warning me-5" @click="cevapEkle(aktifSoru.id, 3)">3</button>
                    <button type="button" class="btn btn-success me-5" @click="cevapEkle(aktifSoru.id, 4)">4</button>
                    <button type="button" style="background-color: #009900de;" class="btn btn-success me-5" @click="cevapEkle(aktifSoru.id, 5)">5</button>
                </div>
                <div class="text-center mt-2" v-if="aktifSoru.type=='scored'">
                <small style="font-size:20px">1 = En kötü &nbsp;&nbsp;|&nbsp;&nbsp; 5 = En iyi</small>
                </div>
                <div class="d-flex justify-content-center mt-5 answer" v-if="aktifSoru.type=='optional'">
                    <button type="button" class="btn btn-info me-5" @click="cevapEkle(aktifSoru.id, 0)">Evet</button>
                    <button type="button" class="btn btn-danger" @click="cevapEkle(aktifSoru.id, -1)">Hayır</button>
                </div>
            </div>
        </div>
         <div v-else-if="cevaplar.length == 6">
             <div class="col-md-12 col-form-label">
                <div class="text-center"> 
                    <h4> <span style="font-weight: normal;">Eklemek istediğiniz birşey var mı?</span></h4>
                    <h4 class="mt-3"><span style="font-weight: normal;">Is there anything you want to add?</span></h4>
                </div>
            </div>
        </div>
        <div v-else-if="cevaplar.length == 7">
             <div class="col-md-12 col-form-label">
                <div class="text-center"> 
                    <h4> <span style="font-weight: normal;">Katılımınız için teşekkür ederiz</span></h4>
                    <h4 class="mt-3"><span style="font-weight: normal;">Thank you for participation</span></h4>
                </div>
            </div>
        </div>
        <div class="text-center" v-if="openQuestion">
            <textarea v-model="comment" class="form-control" placeholder="Evet hayır dışındaki tüm geri dönüşleri buraya yazınız"></textarea>
            <button class="btn btn-primary btn-lg mt-3" v-if="cevaplar.length == surveys.length " @click.prevent="send()">Bitir</button>
        </div>
    </form>
</b-modal>
</template>